import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-125ebfdd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "p-3 bg-white border-top border-bottom border-gray-03" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-size-14 text-weight-500 text-primary-dark" }, "\n        その他の応募日時\n      ", -1))
const _hoisted_4 = { class: "mt-3" }
const _hoisted_5 = { class: "order-list" }
const _hoisted_6 = { class: "order-list-link-text" }

import { computed } from "vue";
import { OrderDetail, SlimOrder } from "@/types/order/Order";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import SimpleOrderListItem from "@/components/molecules/orders/SimpleOrderListItem.vue";
const DISPLAY_ORDER_COUNT = 3;

export default /*#__PURE__*/_defineComponent({
  __name: 'SameOfficeOrders',
  props: {
    orderDetail: {},
    applicableOrders: {}
  },
  setup(__props: any) {

const props = __props;



const orderListLink = computed(() => ({
  name: "SearchByOffice",
  params: {
    officeId: `${props.orderDetail.office.id}`
  },
  hash: "#orderList"
}));
const otherApplicableOrders = computed(() =>
  props.applicableOrders?.filter(order => order.id !== props.orderDetail.id)
);
const otherApplicableOrderCount = computed(
  () => otherApplicableOrders.value?.length || 0
);
const isShow = computed(() => {
  return otherApplicableOrderCount.value > 0;
});
const isShowOrderListLink = computed(() => {
  return otherApplicableOrderCount.value > DISPLAY_ORDER_COUNT;
});

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (isShow.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createTextVNode(),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(otherApplicableOrders.value?.slice(
              0,
              DISPLAY_ORDER_COUNT
            ), (order) => {
                return (_openBlock(), _createBlock(SimpleOrderListItem, {
                  order: order,
                  key: order.id,
                  class: "d-block"
                }, null, 8, ["order"]))
              }), 128))
            ]),
            _createTextVNode(),
            (isShowOrderListLink.value)
              ? (_openBlock(), _createBlock(_component_RouterLink, {
                  key: 0,
                  class: "order-list-link",
                  to: orderListLink.value
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_6, _toDisplayString(`他の募集日時を見る (全${otherApplicableOrderCount.value}件)`), 1),
                    _createTextVNode(),
                    _createVNode(FeatherIcon, {
                      icon: "chevron-right",
                      size: "24"
                    })
                  ], undefined, true),
                  _: 1
                }, 8, ["to"]))
              : _createCommentVNode("", true)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})